import { forwardRef } from 'react';

interface LiveRegionProps {
  priority?: 'polite' | 'assertive';
  className?: string;
}

export const LiveRegion = forwardRef<HTMLDivElement, LiveRegionProps>(({
  priority = 'polite',
  className = 'sr-only',
}, ref) => {
  return (
    <div
      ref={ref}
      className={className}
      aria-live={priority}
      aria-atomic="true"
      role="status"
    />
  );
});

LiveRegion.displayName = 'LiveRegion';